var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["Themes"]: () => __WEBPACK_EXTERNAL_MODULE__ids_tokens_87f441e6__.Themes });